const List = () => import("@/pages/config/widget/List")
const Form = () => import("@/pages/config/widget/Form")
// import List from '@/pages/config/widget/List'
// import Form from '@/pages/config/widget/Form'
import layout from "@/layout/Master"

const data = [
  {
    path: "/config/widget",
    name: "widget-list",
    components: {
      content: List,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Widget" },
        { title: "List", active: true }
      ],
      title: "Widget List",
      module: "Widget",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/config/widget/create",
    name: "widget-create",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Widget" },
        { title: "Create", active: true }
      ],
      title: "Widget Create",
      module: "Widget",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/config/widget/view/:id",
    name: "widget-view",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Widget" },
        { title: "View", active: true }
      ],
      title: "Widget View",
      module: "Widget",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/config/widget/edit/:id",
    name: "widget-edit",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Widget" },
        { title: "Edit", active: true }
      ],
      title: "Widget Edit",
      module: "Widget",
      showLink: false,
      requiresAuth: true
    }
  }
]
export default data
